import { Card } from '@/components/ui/Card';
import { PRICING } from '@/lib/content';
import './Pricing.css';

export function Pricing() {
  return (
    <section className="section section--alt" id="pricing">
      <div className="container">
        <div className="section__head">
          <span className="overline">What it costs</span>
          <h2>One household price, with the legal cover already in it</h2>
        </div>

        <div className="grid grid--3">
          {PRICING.map((tier) => (
            <Card key={tier.name} featured={tier.featured}>
              {tier.featured && <span className="price__flag">Most families start here</span>}
              <h3 className="card__title">{tier.name}</h3>
              <p className="price__amount">
                <span className="price__figure">{tier.price}</span>
                {tier.unit && <span className="price__unit">{tier.unit}</span>}
              </p>
              <p className="card__body">{tier.body}</p>
              <ul className="price__points">
                {tier.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </Card>
          ))}
        </div>

        <p className="price__compare">
          For comparison: a virtual GP subscription runs about $85 a month, and a standalone
          will-and-POA package about $199. CareBee starts at $20 with the POA already in it.
        </p>
      </div>
    </section>
  );
}
